import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DeleteOutlined, MenuOutlined } from "@ant-design/icons";
import { DndContext, PointerSensor, useSensor } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Button, Col, Form, Popconfirm, Row, Table } from "antd";
import { EUserRole } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../../others/i18n.js";
import { useStores } from "../../../../../../../store/root.js";
import { spacing } from "../../../../../../../styles/spacing.js";
import { DraggableRow } from "../../../../../../third-party/dnd/draggable-row.js";
import { PermissionCheck } from "../../../../user/permission.js";
const RuleGroupTable = ({ columns, formName = [], ...restProps })=>{
    const { t } = useTranslation();
    const { rcbAuthenticationStore } = useStores();
    const pointerSensor = useSensor(PointerSensor);
    return /*#__PURE__*/ _jsx(Form.List, {
        name: formName,
        children: (fields, { add, remove, move })=>{
            const tableColumns = [
                {
                    title: t("Sort"),
                    dataIndex: "sort",
                    width: 30,
                    render: ()=>/*#__PURE__*/ _jsx(MenuOutlined, {
                            style: {
                                cursor: "grab",
                                color: "#999"
                            }
                        })
                },
                ...columns
            ];
            if (rcbAuthenticationStore.hasRole(EUserRole.Creator)) {
                tableColumns.push({
                    title: t("Action"),
                    dataIndex: "actions",
                    render: (_, record, index)=>{
                        return /*#__PURE__*/ _jsx(Popconfirm, {
                            placement: "leftTop",
                            title: t("Are you sure to delete this entry?"),
                            onConfirm: ()=>remove(index),
                            okText: t("Yes"),
                            cancelText: t("No"),
                            children: /*#__PURE__*/ _jsx(Button, {
                                icon: /*#__PURE__*/ _jsx(DeleteOutlined, {}),
                                onDoubleClick: ()=>remove(index)
                            })
                        });
                    }
                });
            }
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(PermissionCheck, {
                        minRole: EUserRole.Creator,
                        children: /*#__PURE__*/ _jsx(Row, {
                            style: {
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: spacing.layout.content.padding,
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(Col, {
                                flex: 1,
                                style: {
                                    textAlign: "left"
                                },
                                children: /*#__PURE__*/ _jsx(Button, {
                                    onClick: ()=>add({
                                            id: null,
                                            mustAllRulesBeResolved: false,
                                            mustGroupBeResolved: false
                                        }),
                                    children: t("Add")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(DndContext, {
                        sensors: [
                            pointerSensor
                        ],
                        onDragEnd: (event)=>{
                            const from = fields.findIndex((field)=>field.key === +event.active.id);
                            const to = fields.findIndex((field)=>field.key === +event.over?.id);
                            move(from, to);
                        },
                        children: /*#__PURE__*/ _jsx(SortableContext, {
                            items: fields.map((dataRow)=>String(dataRow.key)),
                            strategy: verticalListSortingStrategy,
                            disabled: !rcbAuthenticationStore.hasRole(EUserRole.Creator),
                            children: /*#__PURE__*/ _jsx(Table, {
                                columns: tableColumns,
                                dataSource: fields,
                                components: {
                                    body: {
                                        row: DraggableRow
                                    }
                                },
                                pagination: false,
                                rowKey: "key",
                                ...restProps
                            })
                        })
                    })
                ]
            });
        }
    });
};
export { RuleGroupTable };
